<template>
  <v-container>
    <v-row>
      <v-col>
          <h2>MULTINIVEL PROFESORES</h2>
          <CRUDIndex
            :permissionRoot="'Multinivel Profesores'"
            :headers="headers"
            :storeModel="storeModel"
            :storeModelPlural="storeModelPlural"
            :itemsPerPage="itemsPerPage"
          />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CRUDIndex from '../globals/CRUDIndex'
export default {
  components: {
    CRUDIndex
  },
  data () {
    return {
      headers: [
        { text: 'Nombre', value: 'name' }
      ],
      storeModel: 'DoyangSurrogation',
      storeModelPlural: 'DoyangSurrogations',
      itemsPerPage: 20
    }
  },
}
</script>

<style>

</style>
